<template>
    <div>
        <a href="#" class="product-link" @click.prevent="sizeSelection = true">Таблица размеров</a>

        <q-dialog v-model="sizeSelection"
                  :transition-show="$q.platform.is.mobile ? 'slide-up' : 'scale'"
                  transition-hide="$q.platform.is.mobile ? 'slide-down' : 'scale'"
                  :maximized="$q.platform.is.mobile">
            <q-card class="modal-sizes-table modal-30">
                <div class="modal-header">
                    <span class="modal-title">{{ header }}</span>
                    <div class="modal-close" @click="sizeSelection=false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px"
                                 viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill=""
                                      d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content table-size">
                    <div class="d-flex">
                        <table-size :has-gender="false" :sizes="tableSizes" :labels="tableSizeLabels">
                        </table-size>
                    </div>
                    <h3>Как определить свой размер?</h3>
                    <div class="row q-col-gutter-x-md">
                        <div v-if="slug === 'shoes'">
                            <p>
                                Поместите ногу на лист бумаги и обведите её контур. Рекомендуется измерить обе ноги,
                                чтобы учитывать больший из результатов. Определите длину, измерив расстояние от пятки до
                                конца самого длинного пальца. Сравните результат с размерами в нашей таблице.
                            </p>
                            <div class="shoes-size-steps row mt-5">
                                <div class="shoes-size-icon shoes-size-1">
                                    <div class="no">1</div>
                                    <img src="/images/svg/shoes-size-1.svg" alt="размер один"/>
                                    <div class="text">
                                        Вам нужно вооружиться листом бумаги, карандашом или шариковой ручкой и линейкой или
                                        сантиметром
                                    </div>
                                </div>
                                <div class="shoes-size-icon shoes-size-2">
                                    <div class="no">2</div>
                                    <img src="/images/svg/shoes-size-2.svg" alt="размер два"/>
                                    <div class="text">
                                        Положите лист бумаги на пол возле стены. Поставьте ногу на лист и приставьте пятку
                                        стопы до
                                        соприкосновения со стеной
                                    </div>
                                </div>
                                <div class="shoes-size-icon shoes-size-3">
                                    <div class="no">3</div>
                                    <img src="/images/svg/shoes-size-3.svg" alt="размер три"/>
                                    <div class="text">
                                        Сделайте метку на бумаге, где заканчивается кончик большого пальца. Повторите
                                        процедуру с другой
                                        ногой
                                    </div>
                                </div>
                                <div class="shoes-size-icon shoes-size-4">
                                    <div class="no">4</div>
                                    <img src="/images/svg/shoes-size-4.svg" alt="размер четыре"/>
                                    <div class="text">
                                        Замерьте длину обеих стоп на бумаге и определите свой размер по нашей таблице.
                                        Определять размер
                                        нужно по самой длинного стопе
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hat-size row" v-else-if="slug === 'hat'">
                            <div class="col-sm-6 col-lg-3 mb-sm-3">
                                <img class="icon" src="/images/svg/hat-size-icon.svg" alt="размер головы"  style="max-height: 175px;" />
                            </div>
                            <div class="col-sm-6 col-lg-9">
                                <p>
                                    В отличии от размерных сеток обуви, размерные сетки головных уборов универсальные. Для точного выбора размера головного убора требуется замерить окружность головы. Это можно сделать при помощи мягкого сантиметра обернув его по окружности головы, она должна проходить поверх ушей и немного выше бровей. Сопоставьте результат замера с нашей таблицей. Если вы выбираете головной убор из не тянущихся материалов , кепки или шляпы с каркасом и в результате замера у вас получилось дробное число или результат попадает между двух размеров, округляйте в большую сторону. Если вы выбираете головной убор из тянущихся материалов, например вязаная шапка, и результат также как и в первом случае дробный или попадает между двух размеров, округляйте в меньшую сторону.
                                </p>
                                <p class="ml-3 mt-4">
                                    При отсутствии мягкой измерительной ленты, обычным шнурком для обуви или ниткой, оберните голову, позже замерьте её длину. Чтобы повысить точность, рекомендуется провести измерение как минимум два раза.
                                </p>
                            </div>
                        </div>
                        <div class="hat-size row" v-else-if="slug === 'gloves'">
                            <div class="row">
                                <div class="col-sm-6 col-lg-3 mb-sm-3">
                                    <img class="icon" src="/images/svg/glove-size-icon.svg" alt="размер перчаток" style="max-height: 175px;" />
                                </div>
                                <div class="col-sm-6 col-lg-9">
                                    <p class="text">Для того чтобы узнать свой размер перчаток всегда измеряйте ведущую руку. Размер определяется по обхвату ладони. Нужно замерить самое широкое место кисти: от развилки между большим и указательным пальцем.
                                        <ul class="mt-3 text">
                                            <li class="mt-3"><div>1</div><p>Возьмите мягкую ленту, ручку или карандаш и лист бумаги для фиксации результатов.</p></li>
                                            <li class="mt-3"><div>2</div><p>Положите руку (правую или левую — для левшей) на лист бумаги, не напрягайте ладонь, и выпрямите пальцы. Замер можно провести на весу. </p></li>
                                            <li class="mt-3"><div>3</div><p>Начните измерение с нулевой отметки ленты, расположив её чуть выше большого пальца, и оберните вокруг ладони так, чтобы второй конец вернулся к началу.</p></li>
                                            <li class="mt-3"><div>4</div><p style="padding-top: 7px;">Зафиксируйте результат в миллиметрах и сопоставьте его с нашей таблицей.</p></li>
                                        </ul>
                                        <p class="text mt-3">Если вы хотите купить зимние перчатки с подкладом, то стоит выбрать на четверть размера больше чем без подклада. Если же хотите приобрести облегающие перчатки без подклада, выбирайте на четверть размера меньше.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'SizeSelection',
    props: [
        'product',
        'brand',
        'brandSizes',
        'sizeKeys',
        'tableSizes',
        'tableSizeLabels',
        'slug'
    ],
    data() {
        return {
            sizeSelection: false
        }
    },
    computed: {
        ...mapState('auth', ['gender']),
        columnWidth() {
            return this.columns.length ? (Math.round(100 * 100 / this.columns.length) / 100) + '%' : '';
        },
        columns() {
            return this.sizes.length ? Object.keys(this.sizes[0]) : [];
        },
        header() {
            let header = '';

            switch (this.product.category_group.id) {
                case 1:
                    header = ((this.gender === 1) ? 'Женская' : 'Мужская') + ' ' + this.product.category_group.name
                    break
                case 2:
                    header = ((this.gender === 1) ? 'Женские' : 'Мужские') + ' ' + this.product.category_group.name
                    break
                case 3:
                    header = ((this.gender === 1) ? 'Женские' : 'Мужские') + ' ' + this.product.category_group.name
                    break
            }

            return header + (this.brand.manufacturer_size ? ' ' + this.brand.name : '')
        },
        manufacturerSize() {
            return this.product.manufacturer_size ? this.product.manufacturer_size : this.brand.manufacturer_size
        },
        sizes() {
            if (this.product.default_sizes) {
                return this.brandSizes[this.product.default_sizes];
            } else {
                return this.brandSizes[this.brand.default_sizes ? this.brand.default_sizes : 0];
            }
        }
    },
    methods: {
        getColumnLabel(key) {
            let sizeKey = _.find(this.sizeKeys, (s) => s.id === key)

            return sizeKey ? sizeKey.name : '';

            if (sizeKey) {
                if (sizeKey.id === this.manufacturerSize && this.manufacturerSize !== 'ru_size') {
                    return 'Размер производителя, ' + sizeKey.name
                }

                return sizeKey.name
            }

            return ''
        }
    }
}
</script>
